import React from "react";
import PropTypes from "prop-types";
import { Box, Stack } from "@mui/material";
import SubmitButton from "../../atoms/buttons/SubmitButton";

const EditActions = ({ canSubmit, customSubmit, label }) => {
  return (
    <Box>
      <Stack spacing={3} direction="row" p={3} justifyContent="center">
        <SubmitButton
          label={label}
          canSubmit={canSubmit}
          customSubmit={customSubmit}
        />
      </Stack>
    </Box>
  );
};

EditActions.propTypes = {
  canSubmit: PropTypes.bool,
  customSubmit: PropTypes.func,
  label: PropTypes.string,
};

export default EditActions;
